const initialValues = {
    isOpen : false,
}

export const reducerLoading = (state = initialValues , action)=>{
switch(action.type){
    case "OPEN-LOADING":
        return{
            ...state,
            isOpen : action.isOpen,
        }

    break;
    default :
        return { ...state }
        break;
}
}